import axios from '@/core/axios';

import {
  AccountingExportFilters,
  AccountingExportResponse,
  AccountingSituationFilters,
  AccountingSituationResponse
} from './accounting-exports.types';

export class AccountingExportsService {
  get(filters: AccountingExportFilters = {}): Promise<AccountingExportResponse> {
    return axios.get<AccountingExportResponse>('/accounting/exports', { params: filters }).then(resp => resp?.data);
  }

  downloadCSV(filters: AccountingExportFilters = {}): Promise<Blob> {
    return axios
      .get('/accounting/exports/csv', {
        params: filters,
        responseType: 'blob'
      })
      .then(resp => resp?.data);
  }

  getSituation(filters: AccountingSituationFilters = {}): Promise<AccountingSituationResponse> {
    return axios
      .get<AccountingSituationResponse>('/accounting/situation-exports', { params: filters })
      .then(resp => resp?.data);
  }

  downloadSituationCSV(filters: AccountingSituationFilters = {}): Promise<Blob> {
    return axios
      .get('/accounting/situation-exports/csv', {
        params: filters,
        responseType: 'blob'
      })
      .then(resp => resp?.data);
  }
}

export const accountingExportsService = new AccountingExportsService();
